import { useEffect } from "react";

const pageNames = {
  "/": "Home",
  "/contact": "Contact Us",
  "/contactUs": "Contact Us",
  "/frequently-asked-questions": "Frequently Asked Questions",
  "/help": "Help",
  "/updates": "Updates",
  "/sitemap": "Sitemap",
  "/Sitemap": "Sitemap",
  "/dashboard": "Dashboard",
  "/login": "Login",
  "/register-login": "Register / Login",
};

// Use the page's own heading so section names and translations stay in sync.
export default function useDocumentTitle(pathname) {
  useEffect(() => {
    const root = document.getElementById("root");
    const updateTitle = () => {
      const heading = document.querySelector("#main-content h1, main h1");
      const pageName = heading?.textContent?.replace(/\s+/g, " ").trim()
        || pageNames[pathname.replace(/\/$/, "") || "/"];
      const title = pageName ? `NMDFC 2.0 | ${pageName}` : "NMDFC 2.0";
      if (document.title !== title) document.title = title;
    };

    updateTitle();
    // Route components may update their section or translated heading after commit.
    const observer = new MutationObserver(updateTitle);
    if (root) observer.observe(root, { childList: true, subtree: true, characterData: true });
    return () => observer.disconnect();
  }, [pathname]);
}
